// extracted by mini-css-extract-plugin
export default {"SkillsEntry":"SkillsEntry_SkillsEntry__iBCH8"};